import {
  SOCIAL_LINK_KEYS,
  SOCIAL_LINK_LABELS,
  type PlatformSocialLinks,
} from '@inflip/contracts/admin';
import { useEffect, useState } from 'react';

import { Field, SavedAt, usePlatformSettings } from '../components/settings-form';
import { Button, ErrorBanner, LoadingRow, PageHeader, Section, inputCls } from '../components/ui';
import { api } from '../lib/api-client';

/** 소셜 링크 — 인플립 공식 SNS 주소. 입력한 것만 웹 하단에 보인다 */
export function SocialLinksSettingsPage() {
  const { session, settings, error, run } = usePlatformSettings();
  const [form, setForm] = useState<PlatformSocialLinks | null>(null);
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState<Date | null>(null);

  useEffect(() => {
    if (settings && !form) setForm(settings.socialLinks);
  }, [settings, form]);

  if (!session) return null;

  const save = async () => {
    if (!form || saving) return;
    setSaving(true);
    setSavedAt(null);
    const ok = await run(() => api.updateSocialLinks(session.accessToken, form));
    if (ok) setSavedAt(new Date());
    setSaving(false);
  };

  return (
    <main className="mx-auto w-full max-w-3xl px-6 py-8">
      <PageHeader
        title="소셜 링크"
        description="인플립 공식 SNS 주소예요. 입력한 것만 웹 하단에 보이고, 비우면 사라져요"
        actions={
          <>
            <SavedAt at={savedAt} />
            <Button disabled={saving || !form} onClick={() => void save()}>
              {saving ? '저장 중…' : '저장'}
            </Button>
          </>
        }
      />
      {error && <ErrorBanner message={error} />}
      {!settings && !error && <LoadingRow />}

      {form && (
        <Section title="링크">
          <div className="space-y-3">
            {SOCIAL_LINK_KEYS.map((key) => (
              <Field key={key} label={SOCIAL_LINK_LABELS[key]}>
                <input
                  className={`w-full ${inputCls}`}
                  type="url"
                  inputMode="url"
                  value={form[key]}
                  maxLength={500}
                  placeholder="https://"
                  onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                />
              </Field>
            ))}
          </div>
        </Section>
      )}
    </main>
  );
}
